import { lazy } from "react";
import { useCart } from "../views/cart/CartContext";
import { Link,useLocation  } from "react-router-dom";
import "./Header.css";

const Search = lazy(() => import("./Search"));
const Header = () => {
  const { cartState  } = useCart();
  const location = useLocation();
  const isAuthPage =
  location.pathname === "/account/signin" || location.pathname === "/account/signup";
  return (
    <header className="p-3 border-bottom bg-light">
  <div className="container-fluid">
    <div className="row align-items-center">
      {/* Logo Section */}
      <div className="col-md-3 text-center text-md-start">
        <Link to="/" className="text-decoration-none">
          <h1 className="logo-title fw-bold text-primary">E-Commerce</h1>
        </Link>
      </div>

      {!isAuthPage && (
        <>
          {/* Search Section */}
          <div className="col-md-5">
            <Search />
          </div>
        </>
      )}
    </div>
  </div>
</header>
  );
};
export default Header;
